import React from 'react';
import "./VerticalCarousel.css";
import Carousel from "./Carousel";

const img_1 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/3+-+Black.webp";
const img_2 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/11+-+White.webp";
const img_3 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/1+-+Pine.webp";
const img_4 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/6+-+Walnut.webp";
const img_9 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/8+-+Vieunite_Mockup_Be+Noticed+Design+-+01.webp";
const img_6 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/2+-+Vieunite+2023+03.webp";
const img_7 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/7+-+Vieunite+2023+02.webp";
const img_8 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/4+-+alexandra-gorn-W5dsm9n6e3g-unsplash.webp";
const img_5 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/9+-+Frames.png";
const vd_1 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/V+FINAL+1080p+-+Single+Logo+End.mp4";
const tb_1 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/1+-+Gallery/20230822-145615.webp";


class VerticalCarousel extends React.Component {
    render() {
        const data = [
            {
                video: vd_1,
                thumbnail:tb_1,
            },
            {
                image: img_1,
            }, {
                image: img_2,
            }, {
                image: img_3,
            }, {
                image: img_4,
            },   {
                image: img_5,
            }, {
                image: img_6,
            }, {
                image: img_7,
            }, {
                image: img_8,
            }, {
                image: img_9,
            },];
        const slideNumberStyle = {
            fontSize: '20px', fontWeight: 'bold',
        }

        return (
            <div style={{textAlign: "center", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '60px'}}>
                <Carousel
                    data={data}
                    time={3000}
                    width="550px"
                    height="450px"
                    radius="10px"
                    slideNumber={false}
                    slideNumberStyle={slideNumberStyle}
                    captionPosition="bottom"
                    automatic={false}
                    dots={false}
                    pauseIconColor="white"
                    pauseIconSize="40px"
                    slideBackgroundColor="darkgrey"
                    slideImageFit="cover"
                    thumbnails={true}
                    thumbnailWidth="100px"
                    thumbnailHeight={'100px'}
                    style={{
                        textAlign: "center",
                        maxWidth: "100vw",
                        // maxHeight: "500px",
                        // margin: "50px auto",
                        // backgroundColor: 'red'
                        backgroundColor: '#f4f4f4'
                    }}
                />
            </div>
        );
    }
}

export default VerticalCarousel;
